import React from "react";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles((theme) => {
  return {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "40px",
      height:"100%",
      [theme.breakpoints.down("sm")]: {
        fontSize: "30px",
      },
    },
  };
});
const NoMatch = (props: any) => {
  const classes = useStyles();
  return (
    <div style={{height: '100%'}}>
      <div className={classes.style}>Page Not Found</div>
    </div>
  );
};

export default NoMatch;
